import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

export default class WordLanguage extends React.Component {

  static propTypes = {
    wordText: PropTypes.string,
    targetLanguage: PropTypes.string
  }

  state = {
    selectedLanguage: this.props.targetLanguage,
  }

  render() {
    if (this.props.targetLanguage !== this.state.selectedLanguage) {
      return (
        <Redirect push to={ `/words/${this.props.wordText}/${this.state.selectedLanguage}` } />
      );
    } else {
      const targetLanguage = this.props.targetLanguage || 'en';
      return (
        <Fragment>
          <select className='item-meta' value={ targetLanguage } onChange={ this.onSelectNewLanguage }>
            <option value="ar">Arabic</option>
            <option value="bg">Bulgarian</option>
            <option value="zh">Chinese</option>
            <option value="hr">Croatian</option>
            <option value="cs">Czech</option>
            <option value="en">English</option>
            <option value="fr">French</option>
            <option value="de">German</option>
            <option value="el">Greek</option>
            <option value="he">Hebrew</option>
            <option value="it">Italian</option>
            <option value="ja">Japanese</option>
            <option value="fa">Persian</option>
            <option value="pt">Portuguese</option>
            <option value="ru">Russian</option>
            <option value="sr">Serbian</option>
            <option value="sl">Slovenian</option>
            <option value="es">Spanish</option>
            <option value="sv">Swedish</option>
            <option value="tr">Turkish</option>
          </select>
        </Fragment>
      );
    }
  }

  onSelectNewLanguage = (e) => {
    this.setState({ selectedLanguage: e.target.value });
  }
}



// WEBPACK FOOTER //
// ./src/components/word/word_language.jsx